import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="reports"
export default class extends Controller {

  static targets = [ "form" ]

  static values = {
    statuses: Array,
    vaccinations: Array
  }

  connect() {
    let searchField = document.querySelector(".reportsSearch")

    searchField.addEventListener("keyup", (event) => {
      let datatable = document.querySelector(".datatable").datatable
      datatable.search(event.target.value).draw()
    })
  }

  submit(event) {
    let datatable = document.querySelector(".datatable").datatable
    datatable.search('').draw()
    this.formTarget.requestSubmit()
  }

  statusChanged(event) {
    let diagnos_field = event.target.closest('tr').querySelector('.diagnos_field')
    let date_medotvod_end_field = event.target.closest('tr').querySelector('.date_medotvod_end_field')
    if (event.target.value && this.statusesValue.includes(parseInt(event.target.value))) {
      diagnos_field.classList.remove('d-none')
      diagnos_field.querySelector('select').choices.enable();
    }
    else {
      diagnos_field.classList.add('d-none')
      diagnos_field.querySelector('select').choices.disable();
    }
  }

  vacinationChanged(event) {
    let date_re_vacination_field = event.target.closest('tr').querySelector('.date_re_vacination_field')
    if (event.target.value && this.vaccinationsValue.includes(parseInt(event.target.value))) {
      date_re_vacination_field.classList.remove('d-none')
    }
    else {
      date_re_vacination_field.classList.add('d-none')
    }
  }
}